import React from 'react'
import { AnimationStartProvider } from './src/context/AnimationStartContext'

// noinspection JSUnusedGlobalSymbols
export const wrapRootElement = ({ element }) => {
  return (
    <AnimationStartProvider>
      {element}
    </AnimationStartProvider>
  )
}

